import React from 'react';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

type Props = Omit<SvgIconProps, 'viewBox'>;

export function HelpIcon(props: Props) {
    const newProps = {
        width: 24,
        height: 24,
        fill: 'none',
        'aria-hidden': true,
        ...props,
        viewBox: '0 0 24 24',
    };
    return React.createElement(
        SvgIcon,
        newProps,
        <path
            d="M3 11h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5Zm0 0a9 9 0 1 1 18 0"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />,
        <path
            d="M21 11h-3a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-5Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />,
        <path
            d="M21 16v2a4 4 0 0 1-4 4h-5"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    );
}
